import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=76508d36&"
import script from "./Info.vue?vue&type=script&lang=js&"
export * from "./Info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\yuichi\\git\\open_coupon\\public\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76508d36')) {
      api.createRecord('76508d36', component.options)
    } else {
      api.reload('76508d36', component.options)
    }
    module.hot.accept("./Info.vue?vue&type=template&id=76508d36&", function () {
      api.rerender('76508d36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/info/Info.vue"
export default component.exports